import script from "./BaseLoader.vue?vue&type=script&lang=ts&setup=true"
export * from "./BaseLoader.vue?vue&type=script&lang=ts&setup=true"

import "./BaseLoader.vue?vue&type=style&index=0&id=4a7bdbad&lang=scss"

const __exports__ = script;

export default __exports__